import api from '../api';

export const enableShare = (modelId, payload = { enable: true }) =>
  api.post(`/share/${modelId}`, payload).then((r) => r.data);

export const disableShare = (modelId) =>
  api.post(`/share/${modelId}`, { enable: false }).then((r) => r.data);

export const getShareStatus = (modelId) =>
  api.get(`/share/${modelId}`).then((r) => r.data);

export const getPublicStory = (token) =>
  api.get(`/share/t/${token}`).then((r) => r.data);

export const getPublicWorlds = () =>
  api.get('/share/public').then((r) => r.data);
